import { Grid, TextField, Typography } from "@mui/material";

export default function DefinicionVariableEspecial({
  monto,
  porcentaje,
  precioMinimo,
  // precioMaximo,
  handleMontoChange,
  handlePorcentajeChange,
  handlePrecioMinimo,
  // handlePrecioMaximo,
}) {
  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Typography ml={1} mt={1} variant="subtitle1">
          Ingrese Porcentaje o Monto de Variación
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <TextField
          label="Variación en Monto"
          variant="outlined"
          size="small"
          fullWidth
          value={monto}
          onChange={handleMontoChange}
          disabled={
            porcentaje !== "" || precioMinimo !== ""
          }
          placeholder="Ej: 100 o -100"
          inputProps={{ inputMode: "decimal" }}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          label="Variación en Porcentaje (%)"
          variant="outlined"
          size="small"
          fullWidth
          value={porcentaje}
          onChange={handlePorcentajeChange}
          disabled={monto !== "" || precioMinimo !== ""}
          placeholder="Ej: 10 o -10"
          inputProps={{ inputMode: "decimal" }}
        />
      </Grid>
      <Grid item xs={12}>
        <Typography ml={2} variant="body2" color="textSecondary">
          * Use valores negativos para descontar. Ej: -10
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Typography ml={1} mt={1} variant="subtitle1">
          Ingrese el Precio Determinado
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <TextField
          label="Precio ($)"
          variant="outlined"
          size="small"
          fullWidth
          // required={precioMaximo !== "" ? true : false}
          required
          value={precioMinimo}
          onChange={handlePrecioMinimo}
          disabled={porcentaje !== "" || monto !== ""}
          placeholder="Ej: 100 o -100"
          inputProps={{ inputMode: "decimal" }}
        />
      </Grid>
      {/* <Grid item xs={6}>
        <TextField
          label="Precio Máximo ($)"
          variant="outlined"
          size="small"
          fullWidth
          required={precioMinimo !== "" ? true : false}
          value={precioMaximo}
          onChange={handlePrecioMaximo}
          disabled={porcentaje !== "" || monto !== ""}
          placeholder="Ej: 10 o -10"
          inputProps={{ inputMode: "decimal" }}
        />
      </Grid> */}
    </Grid>
  );
}
